/**
 * Redirect to Main Site Component
 * Used on specialty sites to redirect About/Testimonials to main site
 */

import React, { useEffect } from 'react';
import { useSite } from '../contexts/SiteContext';

export const RedirectToMainSite = ({ path = '' }) => {
  const { theme } = useSite();
  const mainSiteUrl = `https://drdnreddyortho.com${path}`;

  useEffect(() => {
    // Redirect after a brief moment
    const timer = setTimeout(() => {
      window.location.href = mainSiteUrl;
    }, 100);
    return () => clearTimeout(timer);
  }, [mainSiteUrl]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: theme.lightBgHex }}>
      <div className="text-center">
        <div 
          className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4"
          style={{ borderColor: theme.primaryHex, borderTopColor: 'transparent' }}
        />
        <p className="text-gray-600">Redirecting to main site...</p>
      </div>
    </div>
  );
};

export default RedirectToMainSite;
